module.exports = __webpack_public_path__ + "../resources/img/ic_re_welcome_arc_dr.7aefb7f4.svg";